import React from "react";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

class ConfirmDialog extends React.Component {
	static propTypes = {
		open: PropTypes.bool,
		title: PropTypes.string
	};

	state = {
		message: "",
		captionYes: "Ja",
		captionNo: "Nein",
		handleYes: null,
		handleNo: null
	};

	UNSAFE_componentWillReceiveProps(nextProps) {
		if (nextProps.value !== this.props.value) {
			this.setState({ value: nextProps.value });
		}
	}

	handleClickOpen = () => {
		this.setState({ open: true });
	};

	handleClose = () => {
		this.setState({ open: false });
	};

	render() {
		return (
			<div>
				<Dialog
					open={this.props.open}
					disableBackdropClick
					disableEscapeKeyDown
					aria-labelledby="alert-dialog-title"
					aria-describedby="alert-dialog-description"
				>
					<DialogTitle id="alert-dialog-title">{this.props.title}</DialogTitle>
					<DialogContent>
						<DialogContentText id="alert-dialog-description">
							{this.props.message}
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button onClick={this.props.handleNo} color="primary">
							{this.props.captionNo}
						</Button>
						<Button onClick={this.props.handleYes} color="primary" autoFocus>
							{this.props.captionYes}
						</Button>
					</DialogActions>
				</Dialog>
			</div>
		);
	}
}

export default ConfirmDialog;
